import script from "./LayoutConsole.vue?vue&type=script&setup=true&lang=js"
export * from "./LayoutConsole.vue?vue&type=script&setup=true&lang=js"

import "./LayoutConsole.vue?vue&type=style&index=0&id=35281d47&lang=scss&scoped=true"

import exportComponent from "H:\\project\\tako\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35281d47"]])

export default __exports__